export default "__VITE_ASSET__BnPV5u9U__"